import { CustomerSupportState, CustomerSupportActions } from './types';
import ActionTypes from './constants';

export const initialState: CustomerSupportState = {
  customerSupportList: [],
  isLoading: false,
  sortBy: "updatedAt=desc",
  customerSupportDetailInfo: {},
};

const customerSupportReducer = (
  state: CustomerSupportState = initialState,
  action: CustomerSupportActions,
): CustomerSupportState => {
  switch (action.type) {
    case ActionTypes.SET_CUSTOMER_SUPPORT_LOADER:
      return { ...state, isLoading: action.payload };
    case ActionTypes.CUSTOMER_SUPPORT_LIST_SUCCESS:
      return { ...state, customerSupportList: action.payload };
    case ActionTypes.SET_SORT_BY:
      return { ...state, sortBy: action.payload };
    case ActionTypes.SET_CUSTOMER_SUPPORT_DETAIL:
      return { ...state, customerSupportDetailInfo: action.payload };
    default:
      return state;
  }
};

export default customerSupportReducer;
